import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    activeMarker: {},
    activeMarkerWalkingDistance: false,
    thumbnailVisible: false,
    detailsVisible: false,
    filtersVisible: false,
    languageMenuVisible: false
  },

  getters: {
    activeLocation: state => {
      return state.activeMarker
    },
    activeMarkerWalkingDistance: state => {
      return state.activeMarkerWalkingDistance
    }
  },

  mutations: {
    setActiveLocation (state, marker) {
      state.activeMarker = marker
    },
    activeMarkerWalkingDistance (state, marker) {
      state.activeMarkerWalkingDistance = marker
    }
  },

  actions: {
    toggleThumbnail () {
      this.thumbnailVisible = !this.thumbnailVisible
    },
    toggleDetails () {
      this.detailsVisible = !this.detailsVisible
    },
    activeMarkerWalkingDistance (marker) {
      this.activeMarkerWalkingDistance = marker
    },
    hideDetails () {
      this.detailsVisible = false
    },
    hideLanguageMenu () {
      this.languageMenuVisible = false
    }
  }
})
